type Focusable = {
  focus?: (options?: { preventScroll?: boolean; focusVisible?: boolean }) => void;
};

/**
 * `element.focus({ focusVisible: true })` gibt es nur in Chrome ab 145,
 * Safari ab 18.4 und Firefox ab 104. Ältere Versionen werfen oder ignorieren
 * die Option. Dann reicht `focus({ preventScroll: true })`, zuletzt `focus()`
 * ohne Argument.
 *
 * Der sichtbare Ring kommt aus `:focus-visible` (Chrome ab 86, Safari ab 15.4,
 * Firefox ab 85). Ohne die Option entscheidet der Browser: Tastatur ja,
 * Mausklick nein. `focusVisible: true` deshalb nur aus der Tastaturbehandlung
 * und dem Fehlerfokus, nicht nach einem Klick.
 */
export function focusTarget(node: Focusable | null | undefined, focusVisible: boolean): void {
  if (node == null || typeof node.focus !== "function") return;
  if (focusVisible) {
    try {
      node.focus({ preventScroll: true, focusVisible: true });
      return;
    } catch {
      // Option in diesem Browser unbekannt.
    }
  }
  try {
    node.focus({ preventScroll: true });
  } catch {
    try {
      node.focus();
    } catch {
      // Host ohne Fokus.
    }
  }
}
